<template>
<div class="user-bar">
  <!-- <login-modal v-if="show_login" ref="login_modal" @refreshUser="refreshUser"   ></login-modal> -->
  <div class="navbar-header">
    <button aria-controls="bs-navbar" aria-expanded="false" v-on:click="toggleMobile" class="collapsed navbar-toggle" data-target="#bs-navbar" data-toggle="collapse" type="button">
      <i class="fas fa-bars"></i>
    </button>

    <!-- <a class="navbar-brand" v-on:click="changeSource('garden',true)">{{name}}</a> -->
    <router-link class="navbar-brand" :to="{ name: 'Home', params: { }}">{{name}}</router-link>
  </div>

  <nav class="collapse navbar-collapse" v-bind:class="{ in: show_mobile_nav }">
    <ul class="nav navbar-nav">
      <li  v-bind:class="{ active: is_plan_area }" >

        <mydropdown ref="headerDropdown1">
          <a slot="button" class="dropdown-toggle" v-bind:class="{ loggedIn: user }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" v-on:click="$refs.headerDropdown1.toogle()">
            Đăng ký xuất khẩu
            <span class="caret"></span>
          </a>

          <ul slot="body" class="dropdown-menu">
          <li v-bind:class="{ active: is_plan_area }"><router-link :to="{ name: 'PlanArea', params: { }}">{{'Mã số vùng trồng'|translate}}</router-link></li>
          </ul>
        </mydropdown>

      </li>
      <li  v-bind:class="{ active: is_home }" >

        <mydropdown ref="headerDropdown2">
          <a slot="button" class="dropdown-toggle" v-bind:class="{ loggedIn: user }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" v-on:click="$refs.headerDropdown2.toogle()">
            Dịch vụ hỗ trợ
            <span class="caret"></span>
          </a>

          <ul slot="body" class="dropdown-menu">
          <li v-bind:class="{ active: is_home }"><router-link :to="{ name: 'Home', params: { }}">{{'Khuyến Nông Viên'|translate}}</router-link></li>
          </ul>
        </mydropdown>

      </li>

      <li  v-bind:class="{ active: is_for_seller || is_for_buyer }" >

        <mydropdown ref="headerDropdown3">
          <a slot="button" class="dropdown-toggle" v-bind:class="{ loggedIn: user }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" v-on:click="$refs.headerDropdown3.toogle()">
            Mua bán
            <span class="caret"></span>
          </a>

          <ul slot="body" class="dropdown-menu">
            <li v-bind:class="{ active: is_for_seller }">

            <router-link :to="{name:'MyAgriculturalAds'}">Dành cho người bán</router-link>
            </li>
            <li v-bind:class="{ active: is_for_buyer }">

            <router-link :to="{name:'AgriculturalAds'}">Dành cho người mua</router-link>
            </li>
          </ul>
        </mydropdown>

        </li>


    </ul>

    <ul class="nav navbar-nav navbar-right" v-if="user">
      <li>
        <mydropdown ref="theDropdown">
          <a slot="button" class="dropdown-toggle" v-bind:class="{ loggedIn: user }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" v-on:click="$refs.theDropdown.toogle()">
            <span v-if="user">
              {{user.name}}
              <span v-if="user.invitations > 0">({{user.invitations}})</span><span class="caret"></span>
              <!-- <img v-if="user['feature_image_path']" :src="user.feature_image_path" />
              <img v-if="!user['feature_image_path']" src="/static/images/avatar.jpg" /> -->

            </span>

          </a>

          <ul slot="body" class="dropdown-menu dropdown-menu-right">
            <!--
            <li v-if="!user">
               <a class="login" v-on:click="showLogin()">Đăng nhập</a>
              <a v-on:click="showLogin(null)">{{'Login/Register'|translate}}</a>
            </li>
            -->

            <!-- <li v-if="features.store" v-bind:class="{ active: !is_manage_garden && source == 'store' }">
                <a v-on:click="changeSource('store',true)">{{'Stores'|translate}}</a>
              </li>-->
            <li v-if="user">
               <router-link
          :to="{ name: 'Profile', params: { profileId: user.unique_code }}"
        >{{'View your profile'|translate}}</router-link>
            </li>
            <li v-if="user">
              <router-link :to="{name:'UpdateProfile'}">{{'Settings'|translate}}</router-link>
            </li>

            <li v-if="user">
              <a class="login" v-on:click="logout">{{'Logout'|translate}}</a>
            </li>
          </ul>
        </mydropdown>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import mydropdown from 'vue2-bootstrap-dropdown'
// import loginModal from '@/components/LoginModal'
import Config from '@/helpers/config'
import {
  EventBus
} from '@/helpers/event-bus'
// import firebase from "firebase";
// import { isMobile } from 'mobile-device-detect';
export default {
  name: 'Header',
  components: {
    mydropdown
  },
  props: ['page'],
  data () {
    return {
      source: '',
      user: null,
      show_login: false,
      is_home: false,
      is_products_page: false,
      is_plan_area: false,
      is_for_seller: false,
      is_for_buyer: false,
      role: Config.role,
      name: Config.name,
      features: Config.features,
      show_mobile_nav: false,
      newwindow: null

    }
  },
  methods: {
    getRoleName (roleId) {
      let name = Utils.getRoleName(roleId)
      return name
    },
    toggleMobile () {
      this.show_mobile_nav = !this.show_mobile_nav
    },
    refreshUser () {
      let localUser = this.$localStorage.get('user')
      if (localUser) {
        this.show_login = false
        this.user = JSON.parse(localUser)
      }
    },
    showLogin (type = null) {
      Utils.showLoginZalo(type)
      // console.log('Config.ZALO_LOGIN_URL',Config.ZALO_LOGIN_URL)
      // return;
      // var loginZaloUrl = Config.zaloUrl(type);
      // console.log('Utils.isMobile()', Utils.isMobile())

      // if (Utils.isMobile()) {

      //   location.href = loginZaloUrl;
      // } else {
      //   this.newwindow = window.open(
      //     loginZaloUrl,
      //     "Login",
      //     "height=500,width=450"
      //   );
      //   if (window.focus) {
      //     this.newwindow.focus();
      //   }
      // }
    },
    // changeSource(source, force_link = false) {
    //   this.source = source;
    //   this.$localStorage.set("source", source);

    //   if (source == "store" && force_link) {
    //     this.$router.push("/stores");
    //     this.$emit("changeSource", source);
    //   } else if (location.pathname != "/" && force_link) {
    //     this.$router.push("/gardens");
    //     this.$emit("changeSource", source);
    //   } else {
    //     this.$emit("changeSource", source);
    //     console.log(this.source);
    //   }
    //   if (source == "store") {
    //     document.body.classList.add("store");
    //   } else {
    //     document.body.classList.remove("store");
    //   }
    // },
    logout () {
      this.generalLogOut()
    },
    generalLogOut () {
      this.$localStorage.remove('user')
      this.user = null

      // location.href = "/";
      // EventBus.$emit("updateUser", this.user);
      this.$router.push({
        name: 'Home'
      })
    },

    // refresh use info from server , if fail refresh page and redirect to home
    refreshUserInfo (token = null) {
      let appendHeader = null
      if (token) {
        appendHeader = {
          'Authorization': 'Token ' + token
        }
      }

      Utils.requestV2(this, true, null, appendHeader)
        .get(`/profile/`)
        .then(response => {
          // console.log('response ne',response)
          window.checked_logged_in = true
          // console.log('response refresh',response)
          let data = response.data
          var temp = data
          if (this.user && this.user.id != data.id) {
            this.$router.push('/')
          }

          // temp.phone = this.user.phone.replace('+84','0');
          this.user = temp
          // console.log('this.user',this.user);
          this.$localStorage.set('user', JSON.stringify(this.user))
          this.$emit('refreshUser', {})
          if (token) {
            this.$router.push('/update-profile')
          }
        }).catch((e) => {
          console.log('catch to error', e)
          this.logout()
        })
    },
    refreshHandler (data) {
      if (data) {
        this.user = data
      } else {
        this.refreshUserInfo()
      }
    },
    listenMessageDetail (event) {
      // console.log('event', event)
      try {
        var data = JSON.parse(event.data)
        // console.log('data',data)
        if (data.status === 'ok') {
          this.user = data.data
          this.$localStorage.set('user', JSON.stringify(this.user))
          // this.$emit("refreshUser", {});
          // location.href = "/";
          EventBus.$emit('updateUser', this.user)
          this.$router.push({
            name: 'Home'
          })
          Utils.showSuccess(this, this.$t('Login success'))
        } else {
          return this.$alertify.alertWithTitle(
            this.$t('Confirm'),
            this.$t('Login fail')
          )
        }
        window.newwindow.close()
      } catch (e) {}
    }
  },
  mounted () {
    let localUser = this.$localStorage.get('user')
    let source = this.$localStorage.get('source')

    // console.log('source blah',source)
    source = source || 'garden'
    if (location.pathname.indexOf('store') != -1) {
      source = 'store'
    }
    if (location.pathname.indexOf('garden') != -1) {
      source = 'garden'
    }
    if (
      location.pathname.indexOf('/manage-tracking') !== -1 ||
      location.pathname.indexOf('/s/') !== -1
    ) {
      this.is_manage_garden = true
    }

    this.source = source
    if (this.page) {
      this.source = this.page
    }
    if (location.pathname === '/' || location.pathname === '/vua-thu-mua') {
      this.is_home = true
    }
    if (location.pathname === '/vung-trong') {
      this.is_plan_area = true
    }
    if (location.pathname === '/danh-cho-nguoi-mua') {
      this.is_for_buyer = true
    }
    if (location.pathname === '/danh-cho-nguoi-ban') {
      this.is_for_seller = true
    }

    if (location.pathname.indexOf('/sp') !== -1 || location.pathname.indexOf('/t/') !== -1) {
      this.is_products_page = true
      this.source = ''
    }

    window.addEventListener('message', this.listenMessageDetail)

    /// console.log('source blah2',source)
    // this.changeSource(this.source);
    // console.log('localUser',localUser, typeof(localUser))
    if (localUser) {
      this.user = JSON.parse(localUser)
      if (!window.checked_logged_in) {
        this.refreshUserInfo()
      }
    } else {
      let token = this.$route.query.token
      // console.log('token', token);
      if (token) {
        this.refreshUserInfo(token)
      }
    }

    EventBus.$on('updateUser', this.refreshHandler)
  },
  beforeDestroy () {
    // prevent duplicated event
    // if (this.newwindow) {
    //   this.newwindow.close();
    // }
    window.removeEventListener('message', this.listenMessageDetail)
    EventBus.$off('updateUser', this.refreshHandler)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/Header.vue